import { Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Select } from '@ngxs/store';
import { MenuItem } from 'primeng/api';
import {AppMainComponent} from './app.main.component';
import {BreadcrumbService} from '@app/service/breadcrumb.service';
import {Company} from '@app/domain/company';
import {SesionState} from '@app/state/sesion/sesion.state';
import {TipoNotificacionWeb} from '@app/domain/notificacion-web';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    styleUrls: ['./app.breadcrumb.component.scss']
})
export class AppBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];

    @Select(SesionState.getCompanySelected) companySelected$: Observable<Company>;

    readonly yapeNotificationTypes: TipoNotificacionWeb[] = ['PAGO_YAPE'];

    constructor(public breadcrumbService: BreadcrumbService, public appMain: AppMainComponent) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
